// Dashboard.js

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, useTheme } from "@mui/material";
import { fetchCounts } from "../../../../context/Slice/RegisterSlice";
import { CountAllCategories } from "../../../../context/Slice/VendorManagementSlice";
import "./EventDashboard.css";
import { tokens } from "../../theme";
import Header from "../../EventCoordinatorComponents/Header";
import StatBox from "../../EventCoordinatorComponents/StatBox";
import StarIcon from "@mui/icons-material/Star";
import ArticleIcon from "@mui/icons-material/Article";
import { PureIncrement } from "pure_counter";

const EventCoordinatorDashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const { counts, loading } = useSelector((state) => state.RegisterR);
  const { AllCategories } = useSelector((state) => state.VendorManagementR);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isCollapsed, setIsCollapsed]= useState(false)
  console.log("AllCategories", AllCategories);

 useEffect(() => {
     const handleResize = () => {
       setScreenWidth(window.innerWidth);
       if (window.innerWidth < 768) {
         setIsCollapsed(true);
       }
     };
 
     window.addEventListener("resize", handleResize);
     handleResize(); // Initial check on mount
 
     return () => {
       window.removeEventListener("resize", handleResize);
     };
   }, [setIsCollapsed]);

  useEffect(() => {
    dispatch(fetchCounts());
    dispatch(CountAllCategories());
  }, [dispatch]);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" sx={{marginLeft:isCollapsed ?"0px":"150px"}} alignItems="center">
        <Header title="CO-ORDINATOR  DASHBOARD" />
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="flex"
        flexWrap="wrap" // Enable wrapping for grid items
        gap="30px"
        justifyContent="center" // Center items for smaller screens
      >
        {/* ROW 1 - StatBoxes */}

        <Box
          className="chart-box"
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Events Completed"
            icon={
              <ArticleIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          className="chart-box"
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Events pendings"
            icon={
              <ArticleIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          className="chart-box"
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Rating"
            icon={
              <StarIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EventCoordinatorDashboard;
